document.addEventListener(
  'error',
  (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement)) return;

    const productMedia = image.closest('.product__media-item');
    if (productMedia) {
      const mediaId = productMedia.dataset.mediaId;
      productMedia.hidden = true;
      if (mediaId) {
        document.querySelectorAll(`[data-target="${mediaId}"]`).forEach((thumbnail) => {
          const thumbnailItem = thumbnail.closest('.thumbnail-list__item');
          if (thumbnailItem) thumbnailItem.hidden = true;
        });
      }
      return;
    }

    const promotionalImage = image.closest('.gc-hero, .gc-home-editorial, .gc-home-feature__image');
    if (promotionalImage) promotionalImage.classList.add('gc-image-unavailable');
  },
  true
);
